import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { NodeField } from "./RouteLine";

// Strategic page-specific lead-capture band.
export const CTABand = ({ eyebrow, title, button = "GET STARTED", to = "/contact" }) => (
  <section className="relative py-20 sm:py-24 overflow-hidden bg-[#0B132B]">
    <div className="absolute inset-0 nm-grid-bg opacity-40" />
    <NodeField />
    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 text-center">
      <Reveal>
        {eyebrow && <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-4">{eyebrow}</p>}
        <h2 className="font-head text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-8 leading-tight">{title}</h2>
        <Link to={to}
          className="btn-sheen inline-flex items-center gap-2 nm-gold-bg text-[#0B132B] font-bold px-8 py-4 rounded-full hover:scale-105 transition-transform"
          data-testid="cta-band-btn">
          {button} <ArrowRight size={18} />
        </Link>
      </Reveal>
    </div>
  </section>
);
